export enum MultiAgentDatePickerModeEnum {
	SINGLE = 'single',
	RANGE = 'range',
}
